module.exports = __webpack_public_path__ + "assets/images/project/satellite-images/meta-2015.jpg?v=27db5cd8";